import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { GuestProvider } from './contexts/GuestContext';
import { DemoProvider } from './contexts/DemoContext';
import { AppRoutes } from './router';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <GuestProvider>
          <DemoProvider>
            <Suspense
              fallback={
                <div className="min-h-screen flex items-center justify-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-4 border-orange-500 border-t-transparent"></div>
                </div>
              }
            >
              <AppRoutes />
            </Suspense>
          </DemoProvider>
        </GuestProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
